import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

// 获取批量信息
export const getCity = params => {
  return axios.request({
    url: "/common/clientCity",
    method: "GET",
    params
  });
};
// 获取单个信息
export const getDetails = id => {
  return axios.request({
    url: `/common/clientCity/${id}`,
    method: "GET"
  });
};
// 删除单个信息
export const del = id => {
  return axios.request({
    url: `/common/clientCity/${id}`,
    method: "DELETE"
  });
};
// 修改单个信息
export const update = data => {
  return axios.request({
    url: `/common/clientCity/${data.id}`,
    method: "PUT",
    data
  });
};
// 新增单个信息
export const add = data => {
  return axios.request({
    url: "/common/clientCity",
    method: "POST",
    data
  });
};

// 新增单个信息
export const getFinaDivision = params => {
  return axios.request({
    url: "/common/financialDivision",
    method: "get",
    params
  });
};

export const uploadFile = data => {
  return axios.request({
    url: "/common/clientCity/upload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};

export const dels = data => {
  return axios.request({
    url: "/common/clientCity",
    method: "POST",
    data
  });
};
